const types = require('../../constants/actionTypes');


const opened = () => ({
    type: types.FUNDBOX_OPENED,
});


module.exports = opened;
